<template>
	<div class="logo-css flex justify-center items-start flex-wrap text-center gap-13.5 bg-grey-1 py-6">
		<div>
			<div class="text-xs mb-4">Supervised by</div>
			<img class="logo-kemendagri" :src="`${publicPath}assets/img/perdagangan-gray-1.png`" alt="">
		</div>

		<div>
			<div class="text-xs mb-4">Organized by</div>
			<img class="logo-jfx mr-6" :src="`${publicPath}assets/img/logo-jfx-full-white.png`" alt="">
			<img class="logo-kbi mr-6" :src="`${publicPath}assets/img/logo-kbi-ver3-white.png`" alt="">
			<img class="logo-kmi mr-6" :src="`${publicPath}assets/img/logo-kmi-putih.png`" alt="">
			<img class="logo-ptpos" :src="`${publicPath}assets/img/POSIND_Logo_3. Putih.png`" alt="">
		</div>

		<div>
			<div class="text-xs mb-4">Certified by</div>
			<img class="logo-iso mr-6" :src="`${publicPath}assets/img/logo-ISO_9001-2015.png`" alt="">
			<img class="logo-ira" :src="`${publicPath}assets/img/logo-ira-approved.png`" alt="">
		</div>

		<div>
			<div class="text-xs mb-4">The Refinery is A Member of The LBMA</div>
			<img class="logo-lbma" :src="`${publicPath}assets/img/logo-lbma-white-1.png`" alt="">
		</div>

		<div>
			<div class="text-xs mb-4">The Technology by</div>
			<img class="logo-bei" :src="`${publicPath}assets/img/logo-bei-white-1.png`" alt="">
		</div>
	</div>
</template>

<script>
export default {
	name: 'FooterLogin',

	data() {
		return {
			publicPath: process.env.BASE_URL,
		}
	},
}
</script>

<style>
.logo-css {
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(255, 255, 255, 0.5);
}

.logo-css img {
	opacity: 0.5;
}

.logo-kemendagri {
	width: 10.75em;
}

.logo-jfx {
	width: 6.5em;
}

.logo-kbi {
	width: 5.5em;
}

.logo-bei {
	width: 6.5em;
}

.logo-kmi {
	width: 6em;
}

.logo-ptpos {
	width: 3.75em;
}

.logo-lbma {
	opacity: 1;
	width: 6.75em;
}

.logo-iso {
	opacity: 1 !important;
	width: 3.7em;
}
.logo-ira {
	opacity: 1 !important;
	width: 5.3em;
}
</style>